<div>
    <ng-container *ngFor="let item of breadcrumb | async; let last = last">
        <a [routerLink]="[item.router]" [queryParams]="item.params" class="breadcrumb-link"
              (click)="itemClick(item)" [ngClass]="{ disabled: item.disabled }">{{ item.name }}</a>
        <fa-icon [icon]="icon" class="chevron"></fa-icon>
    </ng-container>
</div>
